const messages = {
  step3: {
    actionBtn: "Log ind",
  },
};

export default {
  messages,
};
